import React from 'react';

export function ProductCardSkeleton({ className = '' }) {
  return (
    <div
      className={`catalog-skeleton-card flex min-h-80 flex-col rounded-3xl border border-hairline/25 bg-card-surface p-4 sm:p-5 ${className}`}
      aria-hidden
    >
      <div className="catalog-skeleton-shimmer mb-3 aspect-square w-full rounded-2xl bg-sky-wash/80" />
      <div className="space-y-2.5">
        <div className="catalog-skeleton-shimmer h-6 w-4/5 rounded-lg bg-sky-wash/80" />
        <div className="flex items-start gap-2.5">
          <div className="catalog-skeleton-shimmer mt-0.5 h-8 w-8 shrink-0 rounded-full bg-sky-wash/80" />
          <div className="flex-1 space-y-2">
            <div className="catalog-skeleton-shimmer h-4 w-3/4 rounded-md bg-sky-wash/80" />
            <div className="flex gap-1.5">
              <div className="catalog-skeleton-shimmer h-4 max-w-[4.5rem] flex-1 rounded-md bg-sky-wash/80" />
              <div className="catalog-skeleton-shimmer h-4 w-16 rounded-md bg-sky-wash/80" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ProductCatalogSkeleton({ count = 8, className = '' }) {
  return (
    <div
      className={`grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-6 lg:grid-cols-4 lg:gap-8 ${className}`}
      aria-busy="true"
      aria-label="در حال بارگذاری محصولات"
    >
      {Array.from({ length: count }).map((_, i) => (
        <ProductCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function SearchDropdownSkeleton({ rows = 4 }) {
  return (
    <div className="py-2" aria-busy="true" aria-label="در حال جستجو">
      <div className="border-b border-hairline/60 px-3 py-2.5">
        <div className="catalog-skeleton-shimmer h-3 w-28 rounded bg-sky-wash/80" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 border-b border-hairline/40 p-3 last:border-b-0">
          <div className="catalog-skeleton-shimmer h-16 w-16 shrink-0 rounded-card bg-sky-wash/80" />
          <div className="flex min-w-0 flex-1 flex-col gap-2 py-0.5">
            <div className="catalog-skeleton-shimmer h-4 w-[78%] rounded-md bg-sky-wash/80" />
            <div className="catalog-skeleton-shimmer h-3 w-[52%] rounded-md bg-sky-wash/80" />
          </div>
          <div className="catalog-skeleton-shimmer hidden h-4 w-14 shrink-0 rounded sm:block bg-sky-wash/80" />
        </div>
      ))}
    </div>
  );
}
